module.exports = {


    PRODUCTS: [
        {
            id: "1",
            name: "Food",
        },
        {
            id: "2",
            name: "Beverage",
        },
        {
            id: "3",
            name: "Laundry",
        },
        {
            id: "4",
            name: "Snack",
        },
        {
            id: "5",
            name: "Chin-Chin",
        },
    ],
    PAYMENT_OPTIONS: [
        {
            id: "1",
            name: "INVOICED",
        },
        {
            id: "2",
            name: "POS",
        },
        {
            id: "3",
            name: "CASH",
        },
        {
            id: "4",
            name: "DIRECT_TRANSFER",
        },
        


    ]

}




